import managementServices from '../services/managementServices';
import { startOfYear } from 'date-fns';
import { dateToBRT } from '../utils/formatDate';
import { ResponseData } from '../@types/managementTypes';

export async function getManagementsDates() {
  const response = await managementServices.getManagementsDates();
  return response;
}

export async function updateManagementsDates(config: ResponseData) {
  const response = await managementServices.updateManagementsDates(config);
  return response;
}

export async function getFilterDates(initialDateMin: string, initialDateMax: string) {
  const response = await managementServices.getManagementsDates();
  console.log('response', response);

  let finalDateMax = initialDateMax;
  let finalDateMin = initialDateMin;

  if (!finalDateMax) {
    finalDateMax = response.data.datetime_map_end;
  }
  if (!finalDateMin) {
    finalDateMin = response.data.datetime_map_begin;
  }

  return {
    dateMin: finalDateMin,
    dateMax: finalDateMax,
    startDateMap: response.data.datetime_map_begin,
    endDateMap: response.data.datetime_map_end,
    fatalDate: response.data.datetime_fatal,
    generalDate: response.data.datetime_general,
  };
}
